import axios from 'axios'
import { baseUrl } from './config'

export function getUsers (limit, offset, email, name, sort, id, social_network_id, fingerprint, ip, block_status) {
  return axios.get(`${baseUrl}/users`, {
    params: {
      limit, offset, email, name, sort, id, social_network_id, fingerprint, ip, block_status
    }
  })
}

export function confirmMultiAcc (id) {
  return axios.get(`${baseUrl}/users/${id}/multi-acc-info`)
}

export function getUser (id) {
  return axios.get(`${baseUrl}/users/${id}`)
}

export function updateUserRole (id, roles) {
  return axios.put(`${baseUrl}/users/${id}/roles`, {
    roles
  })
}

export function resetUserPassword (id, newPassword) {
  return axios.put(`${baseUrl}/users/${id}/force-reset-password`, newPassword)
}

export function getUserStatistics (id) {
  return axios.get(`${baseUrl}/users/${id}/game-statistics`)
}

export function updateUser (id, params) {
  return axios.put(`${baseUrl}/users/${id}`, params)
}
export function giveRole (user, roles) {
  return axios.put(`${baseUrl}/users/${user.id}/roles`, { roles })
}

export function updateReferral (id, params) {
  return axios.put(`${baseUrl}/referral-programs/${id}`, params)
}

export function updateReferralCategory (id, params) {
  return axios.put(`${baseUrl}/referral-categories/${id}`, params)
}

export function updateUserBalance (id, params) {
  return axios.put(`${baseUrl}/users/${id}/balance`, params)
}

export function updateUserVerification (id) {
  return axios.put(`${baseUrl}/users/${id}/verification`)
}

export function updateUserEmail (id, params) {
  return axios.post(`${baseUrl}/users/${id}/email`, params)
}

export function getReferrals (id, params) {
  return axios.get(`${baseUrl}/users/${id}/referrals`, { params })
}

export function getReferralsDeps (id) {
  return axios.get(`${baseUrl}/users/${id}/referrals-deps-info `)
}

export function deleteReferral (id, referral) {
  return axios.delete(`${baseUrl}/users/${id}/referrals/${referral}`)
}

export function getReferralCatgories (with_stats) {
  return axios.get(
    `${baseUrl}/referral-categories`,
    {
      params: {
        sort: 'name:desc',
        with_stats
      }
    }
  )
}

